import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import ListLayout from '../../Generic/ListLayout';
import DataTable from '../../Generic/DataTable';
import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../hooks/useDeleteItem';
import useFilterData from '../../../hooks/useFilterData';
import useFetchData from '../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../hooks/useSetMenu";
import { createLanguageColumn, createGeneralColumn,createActiveColumn, createActionColumn } from '../../Generic/dataGridColumns';
import AuthContext from "../../../context/AuthProvider";
const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useContext(AuthContext);
  const { mainStore, roleStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.RoleMenuType, mainStore.RoleMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  //FetchData and Search


  useFetchData(axiosPrivate, `/Roles`, roleStore);
  const filteredData = useFilterData(toJS(roleStore.role), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  //Delete
  const deleteRole = useDeleteItem(axiosPrivate, '/Roles', roleStore.deleteRole);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteRole, id);
  }, [deleteRole, t]);

  const cols = useMemo(() => [
	createGeneralColumn("name", "roleName", t),
   
    createActiveColumn(t),
	createActionColumn(t,"/Role/Edit",remove)
    // eslint-disable-next-line
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("roleListTitle")}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Role/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);

// import React, { useState, useEffect, useCallback, useMemo,useContext } from 'react';
// import AuthContext from "../../../context/AuthProvider";
// import { toJS } from 'mobx';
// import { observer } from 'mobx-react-lite';
// import { useTranslation } from 'react-i18next';
// import { useStore } from '../../../stores/store';
// import ListLayout from '../../Generic/ListLayout';
// import DataTable from '../../Generic/DataTable';
// import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
// import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
// import useDeleteItem from '../../../hooks/useDeleteItem';
// import useFilterData from '../../../hooks/useFilterData';
// import useFetchData from '../../../hooks/useFetchData';
// import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
// import { useSetMenu } from "../../../hooks/useSetMenu";
// import { createActiveColumn, createActionColumn } from '../../Generic/dataGridColumns';
// import { createGeneralColumn } from '../../Generic/dataGridColumns';
// import { Link } from 'react-router-dom';
// const List = () => {
//   const axiosPrivate = useAxiosPrivate();
//   const { mainStore, roleStore } = useStore();
//   const { t } = useTranslation();
//   const localizedTextsMap = useLocalizedTextsMap();
//   const { auth } = useContext(AuthContext);
//   const [columns, setColumns] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   useSetMenu(mainStore.RoleMenuType, mainStore.RoleMenuNo);

//   //FetchData and Search
//   useFetchData(axiosPrivate, "/Roles", roleStore);
//   const filteredData = useFilterData(toJS(roleStore.role), searchQuery);

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   //Delete
//   const deleteRole = useDeleteItem(axiosPrivate, '/Roles', roleStore.deleteRole);

//   const remove = useCallback((id) => {
//     confirmDeleteDialog(t, deleteRole, id);
//   }, [deleteRole, t]);

//   const cols = useMemo(() => [
//     // createGeneralColumn("id", "roleId", t),
//     createGeneralColumn("name", "roleName", t),
//     createActiveColumn(t),
//     (auth?.components?.includes("/Role/Edit/:id") || auth?.components?.includes("/Role/Delete")) &&
   
   
//     {
//       field: "permissions",
//       headerName: t("rolePermissions"),
//       sortable: false,
//       flex: 0.5,
//       minWidth: 150,
//       headerAlign: "center",
//       align: "center",
//       headerClassName: 'tableHeaderClassName',
//       cellClassName: 'tableCellClassName',
//       renderHeader: (params) => (
//         <span style={{ fontWeight: 600 }}>{params.colDef.headerName}</span>
//     ),
//       renderCell: (params) => (
//         <>
//           <Link to={`${"/Role/Permissions"}/${params.row.id}`}>
//             <i className="bi bi-lock-fill text-success me-3"></i>
//           </Link>


//         </>
//       ),
//     },
//     (createActionColumn(t,
//       (auth?.components?.includes("/Role/Edit/:id") ? "/Role/Edit" : null),
//       (auth?.components?.includes("/Role/Delete") ? remove : null))
//     ),
//      // eslint-disable-next-line
//   ], [t, remove]);

//   useEffect(() => {
//     setColumns(cols);
//     // eslint-disable-next-line
//   }, [t]);

//   return (
//     <ListLayout
//       title={t("roleListTitle")}
//       searchQuery={searchQuery}
//       onSearchChange={handleSearchChange}
//       searchPlaceholder={t("searchPlaceholder")}
//       addButtonLink="/Role/Add"
//       addButtonTitle={t("add")}
//     >
//       <DataTable
//         rows={filteredData}
//         columns={columns}
//         pageSize={pageSize}
//         setPageSize={setPageSize}
//         localeTextsMap={localizedTextsMap}
//       />
//     </ListLayout>
//   );
// };

// export default observer(List);